import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService } from '../services/data.service';
import { ToasterService, CoreImageViewService } from '../services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../modals';

@Component({
  selector: 'app-core-image-slider',
  templateUrl: './core-image-slider.component.html',
})
export class CoreImageSliderComponent implements OnInit {
  @Input() entityType: string = '';
  @Input() entityId: number = 0;
  @Input() editable: boolean = false;
  @Input() large: boolean = false;
  @Output() imagesChange = new EventEmitter<any[]>();

  images: any[] = [];
  index: number = 0;
  deletingImageIds: Set<number> = new Set();
  isLoading: boolean = false;
  bsModalRef?: BsModalRef;
  preview: boolean = false;

  constructor(
    private dataService: DataService,
    private toastr: ToasterService,
    private bsModalService: BsModalService,
    private coreImageView: CoreImageViewService
  ) {}

  ngOnInit(): void {
    this.fetchImages();
  }

  private fetchImages(): void {
    this.isLoading = true;
    this.dataService
      .get(`api/core/images/${this.entityType}/${this.entityId}`)
      .subscribe(
        (images: any[]) => {
          this.images = images;
          this.index = 0;
          this.isLoading = false;
          this.imagesChange.emit(images);
        },
        (err) => {
          this.isLoading = false;
          this.toastr.showError('messages.error');
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  /**
   * Re-fetch images from the server. Call this after an upload or other
   * mutation to keep the slider in sync.
   */
  reload(): void {
    this.fetchImages();
  }

  get current(): any {
    return this.images[this.index];
  }

  shift(step: number): void {
    const n = this.images.length;
    if (n > 1) {
      this.index = (this.index + step + n) % n;
      this.preview = false;
    }
  }

  togglePreview(): void {
    if (this.current?.image_url) {
      this.preview = !this.preview;
    }
  }

  deleteImage(image: any): void {
    this.bsModalRef = this.bsModalService.show(ConfirmModalComponent, {
      initialState: {
        title: 'navigations.delete',
        content: '',
      },
    });
    this.bsModalRef.content.confirmFn = () => {
      this.deletingImageIds.add(image.id);
      this.dataService.delete('api/core/images', image.id).subscribe({
        next: () => {
          this.images = this.images.filter((i) => i.id !== image.id);
          this.index = this.images.length
            ? Math.min(this.index, this.images.length - 1)
            : 0;
          this.deletingImageIds.delete(image.id);
          this.coreImageView.invalidateCache(this.entityType, this.entityId);
          this.toastr.showSuccess('messages.delete');
        },
        error: () => {
          this.deletingImageIds.delete(image.id);
        },
      });
      this.bsModalRef?.hide();
    };
    this.bsModalRef.content.cancelFn = () => {
      this.bsModalRef?.hide();
    };
  }

  isDeleting(imageId: number): boolean {
    return this.deletingImageIds.has(imageId);
  }
}
